var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        { name: "visibilityhandler", rawName: "v-visibilityhandler" },
      ],
    },
    [
      _c("div", { staticClass: "md-layout" }, [
        _c("div", { staticClass: "md-layout-item" }, [
          _c("div", { staticClass: "custom-toolbar" }, [
            _c(
              "div",
              { staticClass: "custom-toolbar-start" },
              [
                _c("h3", { staticClass: "title" }, [
                  _vm._v("Service Areas Dashboard"),
                ]),
                _c("service-areas-dashboard-filter-component", {
                  attrs: { "selected-date": _vm.selectedDate },
                  on: { onFilterDashboard: _vm.handleFilterOrSearch },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "custom-toolbar-end" },
              [
                _vm.$root.isDesktop
                  ? _c("search-component", {
                      attrs: { "search-filter": _vm.currentSearchTextValue },
                      on: { onSearch: _vm.handleServiceAreaSearch },
                    })
                  : _vm._e(),
                _vm.isTeamOwner
                  ? _c(
                      "div",
                      [
                        _c(
                          "router-link",
                          {
                            attrs: {
                              to: {
                                name: "Create service area",
                              },
                            },
                          },
                          [
                            _c(
                              "md-button",
                              {
                                staticClass:
                                  "md-primary md-just-icon md-round pull-right header-button",
                                attrs: { title: "Add Service Area" },
                              },
                              [_c("md-icon", [_vm._v("add")])],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "md-layout" }, [
        _c(
          "div",
          {
            staticClass:
              "md-layout-item md-small-size-100 md-medium-size-100 md-layout md-large-size-66 md-xlarge-size-66",
          },
          [
            _c("div", { staticClass: "md-layout" }, [
              _vm.serviceAreasWithDeliveryWindows.length
                ? _c(
                    "div",
                    { staticClass: "md-layout-item margin-space-bot px-0" },
                    [
                      _c(
                        "div",
                        { staticClass: "margin-space-bot" },
                        [
                          !_vm.isLoading &&
                          _vm.serviceAreasWithDeliveryWindows.length
                            ? _c(
                                "md-button",
                                {
                                  staticClass: "md-primary expand-btn ml-0",
                                  on: { click: _vm.handleExpandAll },
                                },
                                [
                                  _vm._v(
                                    "\n                            Expand All\n                        "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._l(
                        _vm.serviceAreasWithDeliveryWindows,
                        function (serviceAreaItem) {
                          return _c(
                            "md-list",
                            {
                              key: serviceAreaItem.serviceAreaId,
                              staticClass: "service-area-schedules-body",
                            },
                            [
                              _c(
                                "md-list-item",
                                {
                                  attrs: {
                                    "md-expand": "",
                                    "md-ripple": false,
                                    "md-expanded": serviceAreaItem.isOpen,
                                  },
                                  on: {
                                    "update:mdExpanded": function ($event) {
                                      return _vm.$set(
                                        serviceAreaItem,
                                        "isOpen",
                                        $event
                                      )
                                    },
                                    "update:md-expanded": function ($event) {
                                      return _vm.$set(
                                        serviceAreaItem,
                                        "isOpen",
                                        $event
                                      )
                                    },
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.handleServiceAreaItemClick(
                                        serviceAreaItem
                                      )
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      class: [
                                        "service-area-accordion-header",
                                        {
                                          "service-area-open":
                                            serviceAreaItem.isOpen,
                                        },
                                        serviceAreaItem.capacityBorder,
                                      ],
                                    },
                                    [
                                      serviceAreaItem.isCapacityDetailsLoading &&
                                      !serviceAreaItem.isOpen
                                        ? _c("div", {
                                            staticClass: "btn-loader",
                                          })
                                        : _vm._e(),
                                      _c(
                                        "div",
                                        { staticClass: "service-area-name" },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(serviceAreaItem.name) +
                                                "\n                                    "
                                            ),
                                          ]),
                                        ]
                                      ),
                                      _vm.isTeamOwner
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "service-area-actions",
                                            },
                                            [
                                              _c(
                                                "router-link",
                                                {
                                                  attrs: {
                                                    to: {
                                                      name: "Delivery Windows",
                                                      params: {
                                                        serviceAreaId:
                                                          serviceAreaItem.serviceAreaId,
                                                      },
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "service-area-edit",
                                                    },
                                                    [
                                                      _c("md-icon", [
                                                        _vm._v("edit"),
                                                      ]),
                                                      _c(
                                                        "md-tooltip",
                                                        {
                                                          attrs: {
                                                            "md-direction":
                                                              "left",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Edit Service Area"
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                  _c(
                                    "md-list",
                                    {
                                      attrs: { slot: "md-expand" },
                                      slot: "md-expand",
                                    },
                                    [
                                      !serviceAreaItem.isCapacityDetailsLoading
                                        ? _c(
                                            "div",
                                            [
                                              _c(
                                                "service-areas-dashboard-capacity-component",
                                                {
                                                  attrs: {
                                                    "selected-date":
                                                      _vm.selectedDate,
                                                    "service-area-item":
                                                      serviceAreaItem,
                                                  },
                                                }
                                              ),
                                            ],
                                            1
                                          )
                                        : _c(
                                            "div",
                                            { staticClass: "empty-container" },
                                            [
                                              serviceAreaItem.isCapacityDetailsLoading
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "table-loader",
                                                    },
                                                    [
                                                      _c("fade-loader", {
                                                        attrs: {
                                                          loading: true,
                                                          color: "#333333",
                                                        },
                                                      }),
                                                      _c("span", [
                                                        _vm._v("LOADING"),
                                                      ]),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        }
                      ),
                    ],
                    2
                  )
                : _c(
                    "div",
                    { staticClass: "md-layout-item margin-space-bot" },
                    [
                      !_vm.isLoading
                        ? _c("div", { staticClass: "empty-message" }, [
                            _c("span", { staticClass: "text-center" }, [
                              _vm._v("No service areas available."),
                            ]),
                          ])
                        : _vm._e(),
                    ]
                  ),
            ]),
          ]
        ),
        _c(
          "div",
          {
            staticClass:
              "md-layout-item md-small-size-100 md-layout md-medium-size-100 md-large-size-33 md-xlarge-size-33",
          },
          [
            _c("service-areas-dashboard-blockout-days-component", {
              attrs: {
                "is-loading": _vm.isLoading,
                "blockout-days": _vm.blockoutDays,
              },
            }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }